<template>
  <CarrierMessagesSearchForm />
  <MessagesTable :detailed="true" />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import MessagesTable from '@/views/Components/CarrierMessages/CarrierMessagesTable.vue'
import CarrierMessagesSearchForm from '@/views/Staff/Proxy/Carrier/SearchForm.vue'

export default defineComponent({
  name: 'CarrierMessagesPage',
  components: { CarrierMessagesSearchForm, MessagesTable },
})
</script>
